<template>
	<div class="layout-topbar">
		<button class="p-link layout-menu-button" @click="onMenuToggle">
			<span class="pi pi-bars"></span>
		</button>
		<div class="layout-topbar-icons">
			<button class="p-link">
				<LanguageSelector style="float: right" v-on:languageChanged="onLanguageChanged" />
			</button>
		</div>
		<div class="layout-topbar-icons">
			<button class="p-link" @click="gotToChat()" style="float: left">
				<!-- <span class="layout-topbar-item-text">Events</span> -->
				<span class="layout-topbar-icon pi pi-comments"></span>
				<span class="layout-topbar-badge">{{messagePendingToRead}}</span>
			</button>
			<button class="p-link" @click="gotToAccount()" style="float: left">
				<!-- <span class="layout-topbar-item-text">User</span> -->
				<span class="layout-topbar-icon pi pi-user"></span>
			</button>
		</div>

	</div>
</template>

<script>
import WhatChatService from "@/service/WhatChatService";
import AuthService from "@/service/AuthService";

export default {
	data: function () {
		return {
			messagePendingToRead: 0,
			interval: 300000, // 5 minutes
		};
	},
	authService: null,
	whatChatService: null,
	created() {
		this.whatChatService = new WhatChatService();
		this.authService = new AuthService();

		this.intervalCheckMessages();
	},
	methods: {
		onLanguageChanged() {
			this.$emit("languageChanged");
		},
		onMenuToggle(event) {
			this.$emit("menu-toggle", event);
		},
		gotToAccount() {
			window.location = "#/account";
			return;
		},
		gotToChat() {
			this.messagePendingToRead = 0;
			window.location = "#/negotiationRoom";
			return;
		},
		intervalCheckMessages() {
			var self = this;

			this.getCountPendingMessagesToRead();

			this.handlerTimer = setInterval(function () {
				self.getCountPendingMessagesToRead();
			}, self.interval);
		},
		getCountPendingMessagesToRead() {
			var self = this;

			this.whatChatService
				.getCountPendingMessagesToRead(this.authService.getUserId())
				.then(
					(res) => {
						self.messagePendingToRead = res.data;
					},
					function (err) {}
				);
		},
	},
};
</script>